import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { UpdateKomaModel } from '../vo/update-koma.model';

/**
 * コマ情報を更新する
 *
 * @export
 * @class UpdateKomaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class UpdateKomaService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private vo: UpdateKomaModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateKomaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Koma: {
          parameter: {
            KomaID: this.vo.komaID
          },
          condition: {
            SectionID: this.vo.sectionID,
            PositionX: this.vo.positionX,
            PositionY: this.vo.positionY,
            SizeW: this.vo.sizeW,
            SizeH: this.vo.sizeH,
            PageNum: this.vo.pageNum,
            PublishAmountLimitNum: this.vo.publishAmountLimitNum
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400KomaPageModel} model モデルクラス
   * @param {*} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof UpdateKomaService
   */
  /**
   * API呼び出し
   *
   * @param {UpdateKomaModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof UpdateKomaService
   */
  execute(vo: UpdateKomaModel, successFunction: Function) {
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14updateKoma', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof UpdateKomaService
   */
  success(_: any) {
    this.successFunction();
  }
}
